<template>
    <modal :show="value"
           @close="cancel"
           modal-classes="modal-md modal-dialog-centered">
        <h6 slot="header" class="modal-title" id="modal-title-notification">{{ task.title }}</h6>
        <div class="py-3">
            <form-create-answer-task
              :task="task"
              @onSend="confirm"
            >
            </form-create-answer-task>
        </div>
    </modal>
</template>

<script>
    import FormCreateAnswerTask from "../../views/Forms/Learn/FormCreateAnswerTask";

    export default {
      name: "ModalLessonTaskAddAnswer",
      components: {FormCreateAnswerTask},
      props: {
        value: {
          type: Boolean,
          default: false,
          description: "Show/hide modal state"
        },
        task: {
          type: Object,
          required: true
        },
        id: {
          type: Number,
          required: true,
          description: "Current task index in ToDo array on parent component"
        }
      },
      methods: {
        cancel() {
          this.$emit('onCancel', this.id)
        },
        confirm() {
          this.$emit("onSend", this.id)
        }
      },
    }
</script>

<style scoped>
</style>
